/**
 * 直播间中充值弹层
 */
import React, { Component } from "react";
import RechargeView from '../recharge';
import Cache from 'c-cache';

class RechargePop extends Component {
	
	constructor(props) {
		super(props);
        this.state = {
            isLoggedIn: UP.Global.isLogin(),
            showRechargePop: 0
        }
        
        this.cache = new Cache({
            prefix: 'pcuplive'
        });

        const clientHeight = document.documentElement && document.documentElement.clientHeight || body && body.offsetHeight || window.innerHeight || 600;
        const height = Math.min(Math.floor(clientHeight - 80), 1000);
        const width = 800;
		
		this.style = {
			width,
			height,
			marginLeft: - width / 2 + 'px',
            marginTop: - height /2 + 'px'
		}
	}

    componentWillMount(){

        if (!this.state.isLoggedIn) {
            $.channel.emit('login');
            return;
        }

        this.toggleScrollBar(false);

    }

    componentWillUnmount() {
    	this.toggleScrollBar(true);
    }

    toggleScrollBar(isVisible){
        if (isVisible) {
            $('#wrap').css({
                height: 'auto',
                overflow: 'auto'
            });
        } else {
            $('#wrap').css({
                height: document.documentElement.clientHeight,
                overflow: 'hidden'
            });
        }
    }

	onClose(){
		this.props.onClose();
	}

	render() {
		return (
			<div className="recharge-pop">
				<div className="box" style={this.style}>
					<div className="recharge-pop-hd">
						<span className="close" onClick={()=>this.onClose()}>x</span>
					</div>
					<div className="recharge-pop-bd">
						<RechargeView type="pop"/>
					</div>
				</div>
			</div>
		);
	}
}

export default RechargePop;


// WEBPACK FOOTER //
// ./js/mall/recharge-pop/index.js